import { LimitToI18nKey } from '../constants/Ebx638Features';
export const filterLimits = usageLimitsResponse => {
  return usageLimitsResponse.filter(usageLimit => {
    return Object.keys(LimitToI18nKey).includes(usageLimit.limitName);
  });
};
export const sortLimits = usageLimitResponse => {
  return usageLimitResponse.sort((a, b) => a.limitName > b.limitName ? 1 : b.limitName > a.limitName ? -1 : 0);
};